import { resetPassword } from '../../actions/passwordReset';
import SetPasswordForm from './SetPasswordForm';

export default function ResetPassword() {
  return (
    <SetPasswordForm
      thunk={resetPassword}
      side={{
        eyebrow: 'Account recovery',
        headline: 'Almost there — pick a new password.',
        paragraph:
          'Choose a strong password you don’t use elsewhere. Once it’s set we’ll sign you straight in to your workspace.',
      }}
      bracket="[ Security · Password reset ]"
      headline="Set a new password."
      lede="Create a new password for your account. Minimum 10 characters."
      ctaLabel="Update password & sign in →"
      requestNewLinkTo="/forgot-password"
      errorHeadline="This link is no longer valid."
      errorBody="This reset link has expired or already been used. Request a fresh one and we’ll email you a new link."
    />
  );
}
